module.exports = __webpack_public_path__ + "static/Site-3-fd5c3d5648392dbae3f4d63b11e5e8b9.jpg";